import { AgentKind } from '@/components/AgentChat/AgentKindProvider'

// Keyed per agent kind, though only the staff chat gates writes today.
const autoAcceptKey = (kind: AgentKind): string => `agent-chat-auto-accept:${kind}`

export function getStoredAutoAccept(kind: AgentKind): boolean {
  return window.localStorage.getItem(autoAcceptKey(kind)) === 'true'
}

export function setStoredAutoAccept(kind: AgentKind, on: boolean): void {
  window.localStorage.setItem(autoAcceptKey(kind), String(on))
}
